import React from 'react';
import { Box, Typography, Paper, useTheme, Tooltip, IconButton } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import { ScorecardSubsection } from '../types';
import MetricTable from './MetricTable';

interface ScorecardSectionProps {
  title: string;
  subsection: ScorecardSubsection;
}

const ScorecardSection: React.FC<ScorecardSectionProps> = ({ title, subsection }) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 1.5,
        backgroundColor: 'background.paper',
        boxShadow: '0 2px 8px rgba(15, 40, 76, 0.05)',
        mb: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          mb: 2,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: '1.1rem',
            color: theme.palette.primary.main,
          }}
        >
          {title}
        </Typography>
        <Tooltip
          title={
            <Box>
              <Typography component="span">{subsection.whyItMatters}</Typography>
            </Box>
          }
          arrow
          placement="top"
          sx={{
            maxWidth: 400,
          }}
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: theme.palette.grey[800],
                fontSize: '0.875rem',
                padding: '12px',
                maxWidth: '400px',
                lineHeight: 1.6,
              },
            },
            arrow: {
              sx: {
                color: theme.palette.grey[800],
              },
            },
          }}
        >
          <IconButton
            size="small"
            sx={{
              padding: '4px',
              color: theme.palette.primary.main,
              '&:hover': {
                backgroundColor: 'rgba(15, 40, 76, 0.08)',
              },
            }}
          >
            <InfoIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <MetricTable metrics={subsection.metrics} />
    </Paper>
  );
};

export default ScorecardSection;

